import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["title", "intent", "children", "dismissible", "withIcon", "buttons", "buttonsAlign", "className", "classes", "onDismiss"];
/* eslint-disable no-use-before-define */
/* eslint-disable react/no-unused-prop-types */
import * as React from 'react';
import clsx from 'clsx';
import { useTranslator } from '@gandi/translate';
import Svg from '../../Svg';
import { AddonButton } from '../../AddonButton';
import { Base } from '../../Base';
var styles = {
  "root": "Message-root_1jQn8",
  "icon": "Message-icon_2MFxA",
  "content": "Message-content_1Effi",
  "iconWrapper": "Message-iconWrapper_3m0cK",
  "closeWrapper": "Message-closeWrapper_7_cc1",
  "footer": "Message-footer_YptLx",
  "intentInfo": "Message-intentInfo_1QlgP",
  "intentSuccess": "Message-intentSuccess_2ZIeh",
  "intentWarning": "Message-intentWarning_32zFX",
  "intentDanger": "Message-intentDanger_3Fz-p",
  "intentProgress": "Message-intentProgress_348dh"
};
var iconsMap = {
  info: 'infoWire',
  success: 'successWire',
  warning: 'warningWire',
  danger: 'dangerWire',
  unknown: 'questionWire',
  progress: 'infoWire'
};
function Message(_ref) {
  var _clsx;
  var title = _ref.title,
    _ref$intent = _ref.intent,
    intent = _ref$intent === void 0 ? 'info' : _ref$intent,
    children = _ref.children,
    dismissible = _ref.dismissible,
    withIcon = _ref.withIcon,
    buttons = _ref.buttons,
    _ref$buttonsAlign = _ref.buttonsAlign,
    buttonsAlign = _ref$buttonsAlign === void 0 ? 'start' : _ref$buttonsAlign,
    className = _ref.className,
    classes = _ref.classes,
    onDismiss = _ref.onDismiss,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  var blockVariant = typeof title === 'string' && title.length > 0;
  var inlineVariant = !blockVariant;
  var hasCloseButton = dismissible === true && typeof onDismiss === 'function';
  var rootClasses = clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles.intentInfo, intent === 'info'), _defineProperty(_clsx, styles.intentSuccess, intent === 'success'), _defineProperty(_clsx, styles.intentWarning, intent === 'warning'), _defineProperty(_clsx, styles.intentDanger, intent === 'danger'), _defineProperty(_clsx, styles.intentProgress, intent === 'progress'), _clsx), className);
  var contentClasses = clsx(styles.content, classes === null || classes === void 0 ? void 0 : classes.content);
  return /*#__PURE__*/React.createElement(Root, _extends({
    className: rootClasses
  }, extraProps), withIcon && /*#__PURE__*/React.createElement(Base, {
    flex: true,
    flexShrink0: true,
    flexAlignItemsCenter: true,
    className: styles.iconWrapper
  }, /*#__PURE__*/React.createElement(Svg, {
    name: iconsMap[intent],
    theme: intent,
    className: styles.icon
  })), blockVariant && /*#__PURE__*/React.createElement(Base, {
    flex: true,
    flexCol: true,
    gap: "spacing-3x",
    flexGrow1: true
  }, /*#__PURE__*/React.createElement(Base, {
    flex: true,
    gap: "spacing-2x",
    className: styles.header
  }, /*#__PURE__*/React.createElement(Title, {
    flexGrow1: true
  }, title), hasCloseButton && /*#__PURE__*/React.createElement(Base, {
    flex: true,
    flexShrink0: true,
    flexAlignItemsCenter: true,
    className: styles.closeWrapper
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onDismiss
  }))), /*#__PURE__*/React.createElement("div", {
    className: contentClasses
  }, children), /*#__PURE__*/React.createElement(Footer, {
    buttons: buttons,
    buttonsAlign: buttonsAlign
  })), inlineVariant && /*#__PURE__*/React.createElement(Base, {
    flex: true,
    flexCol: true,
    gap: "spacing-3x",
    flexGrow1: true
  }, /*#__PURE__*/React.createElement(Base, {
    flex: true,
    gap: "spacing-2x"
  }, /*#__PURE__*/React.createElement(Base, {
    flexGrow1: true,
    className: contentClasses
  }, children), hasCloseButton && /*#__PURE__*/React.createElement(Base, {
    flex: true,
    flexShrink0: true,
    flexAlignItemsCenter: true,
    className: styles.closeWrapper
  }, /*#__PURE__*/React.createElement(CloseButton, {
    onClick: onDismiss
  }))), /*#__PURE__*/React.createElement(Footer, {
    buttons: buttons,
    buttonsAlign: buttonsAlign
  })));
}
var Root = function Root(props) {
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(Base, _extends({
      flex: true,
      gap: "spacing-2x",
      boxSizing: "border",
      paddingTop: "spacing-4x",
      paddingRight: "spacing-4x",
      paddingBottom: "spacing-4x",
      borderRadius: "1x",
      backgroundColor: "white"
    }, props))
  );
};
var Title = function Title(props) {
  return /*#__PURE__*/React.createElement(Base, _extends({
    tagName: "h3",
    size: "base",
    weight: "semibold",
    margin: "none"
  }, props));
};
function Footer(props) {
  var buttons =
  // Make sure to remove void | null entries.
  React.Children.toArray(props.buttons).filter(React.isValidElement);

  // Prevent printing an empty element, with its layout.
  if (!buttons.length) return null;
  return /*#__PURE__*/React.createElement(Base, {
    flex: true,
    flexWrap: true,
    flexJustifyCenter: props.buttonsAlign === 'center',
    flexJustifyEnd: props.buttonsAlign === 'end',
    className: styles.footer
  }, buttons);
}
function CloseButton(props) {
  var _useTranslator = useTranslator(),
    __ = _useTranslator.__;
  return /*#__PURE__*/React.createElement(AddonButton, _extends({
    intent: "remove",
    size: "xs",
    hitzone: "overlay"
  }, props), __('Dismiss'));
}
export default Message;